<pdq-card variant="popover" color="white">
  <div class="card-content">
    <pdq-heading element="h6">Display Conditions</pdq-heading>
    <pdq-divider></pdq-divider>
    <span class="body-14-regular">This extension will only appear if:</span>
    <pdq-rules-dynamic-form
      [formGroup]="formGroup"
      formArrayFieldName="displayRules"
      [rules]="displayRules | addCurrencyOption: shopCurrencySymbol"
      [entities]="displayRulesEntities"
      [shopCurrencySymbol]="shopCurrencySymbol"
      [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
  </div>
</pdq-card>
